// Implementation Reconciliation — shared labels, options, and badge styles (matches Command Center tokens).

export const RECON_STATUS_STYLES = {
  "Not Started": "bg-slate-100 text-slate-600 border-slate-200",
  "Processing": "bg-blue-100 text-blue-800 border-blue-200",
  "AI Review Complete": "bg-blue-100 text-blue-800 border-blue-200",
  "Admin Review": "bg-amber-100 text-amber-800 border-amber-200",
  "Awaiting Information": "bg-amber-100 text-amber-800 border-amber-200",
  "Remediation in Progress": "bg-amber-100 text-amber-800 border-amber-200",
  "Final Validation": "bg-gold/20 text-gold-dark border-gold/40",
  "Completed": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Reopened": "bg-violet-100 text-violet-800 border-violet-200",
};

export const RECON_STATUSES = [
  "Not Started", "Processing", "AI Review Complete", "Admin Review", "Awaiting Information",
  "Remediation in Progress", "Final Validation", "Completed", "Reopened",
];

export const READINESS_STYLES = {
  "Audit Ready": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Nearly Ready": "bg-gold/20 text-gold-dark border-gold/40",
  "At Risk": "bg-amber-100 text-amber-800 border-amber-200",
  "Not Ready": "bg-red-100 text-red-800 border-red-200",
  "Manual Review Required": "bg-violet-100 text-violet-800 border-violet-200",
};

export const CONTROL_STATUS_STYLES = {
  "Confirmed Implemented": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Partially Confirmed": "bg-amber-100 text-amber-800 border-amber-200",
  "Implemented but Evidence Missing": "bg-amber-100 text-amber-800 border-amber-200",
  "SSP Claims Implementation but Report Does Not Confirm": "bg-red-100 text-red-800 border-red-200",
  "Report Confirms Implementation but SSP Needs Updating": "bg-blue-100 text-blue-800 border-blue-200",
  "Not Implemented": "bg-red-100 text-red-800 border-red-200",
  "Conflicting Information": "bg-red-100 text-red-800 border-red-200",
  "Not Applicable": "bg-slate-100 text-slate-600 border-slate-200",
  "Needs Manual Review": "bg-violet-100 text-violet-800 border-violet-200",
  "Ready for Validation": "bg-gold/20 text-gold-dark border-gold/40",
  "Approved by ComplyX": "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const CONTROL_STATUSES = Object.keys(CONTROL_STATUS_STYLES);

export const DIMENSIONS = [
  { key: "technical", label: "Technical Configuration" },
  { key: "policy", label: "Policy" },
  { key: "procedure", label: "Procedure" },
  { key: "operational", label: "Operational Execution" },
  { key: "evidence", label: "Evidence" },
  { key: "ssp_accuracy", label: "SSP Accuracy" },
  { key: "training", label: "Training" },
  { key: "personnel", label: "Personnel Responsibility" },
  { key: "monitoring", label: "Ongoing Monitoring" },
];

export const DIM_VALUES = ["Complete", "Partial", "Missing", "Not Confirmed", "Not Applicable", "Needs Manual Review"];

export const DIM_STYLES = {
  "Complete": "bg-emerald-100 text-emerald-800",
  "Partial": "bg-amber-100 text-amber-800",
  "Missing": "bg-red-100 text-red-800",
  "Not Confirmed": "bg-amber-100 text-amber-800",
  "Not Applicable": "bg-slate-100 text-slate-600",
  "Needs Manual Review": "bg-violet-100 text-violet-800",
};

export const RESPONSIBLE_PARTIES = ["ComplyX", "Implementation Partner", "Client", "Shared"];
export const PARTY_STYLES = {
  "ComplyX": "bg-navy/10 text-navy",
  "Implementation Partner": "bg-blue-100 text-blue-800",
  "Client": "bg-gold/20 text-gold-dark",
  "Shared": "bg-violet-100 text-violet-800",
};

export const PRIORITIES = ["Critical", "High", "Medium", "Low"];
export const PRIORITY_STYLES = {
  "Critical": "bg-red-100 text-red-800 border-red-200",
  "High": "bg-amber-100 text-amber-800 border-amber-200",
  "Medium": "bg-blue-100 text-blue-800 border-blue-200",
  "Low": "bg-slate-100 text-slate-600 border-slate-200",
};

export const PARTNER_TYPES = [
  "Microsoft Cloud Partner", "Managed Service Provider", "Security Integrator",
  "Internal IT Team", "Compliance Partner", "Other",
];

export const RECON_SUBROLES = [
  { value: "super_admin", label: "Super Admin" },
  { value: "compliance_admin", label: "Compliance Admin" },
  { value: "compliance_reviewer", label: "Compliance Reviewer" },
];

export const CMMC_LEVELS = ["Level 1", "Level 2", "Level 3", "Not scoped yet"];
export const SSP_STATUSES = ["No SSP", "Draft", "In Review", "Approved", "Needs Update"];

export const PROCESSING_STAGES = [
  "Preparing files", "Reading SSP", "Reading implementation report",
  "Extracting control references", "Matching implementation claims",
  "Evaluating control coverage", "Identifying evidence gaps",
  "Identifying contradictions", "Recommending responsibility assignments",
  "Preparing reconciliation workspace",
];

export const AI_NOTICE = "AI-generated findings are preliminary and must be reviewed and approved by ComplyX before use.";

export const ACTION_STATUSES = ["New", "Assigned", "In Progress", "Waiting on ComplyX", "Waiting on Implementer",
  "Waiting on Client", "Evidence Submitted", "Ready for Validation", "Closed", "Rejected", "Deferred"];

export const KANBAN_COLUMNS = ["New", "Assigned", "Waiting on ComplyX", "Waiting on Implementer",
  "Waiting on Client", "Evidence Submitted", "Ready for Validation", "Closed"];

export const ACTION_STATUS_STYLES = {
  "New": "bg-slate-100 text-slate-700 border-slate-200",
  "Assigned": "bg-blue-100 text-blue-800 border-blue-200",
  "In Progress": "bg-blue-100 text-blue-800 border-blue-200",
  "Waiting on ComplyX": "bg-navy/10 text-navy border-navy/20",
  "Waiting on Implementer": "bg-amber-100 text-amber-800 border-amber-200",
  "Waiting on Client": "bg-gold/20 text-gold-dark border-gold/40",
  "Evidence Submitted": "bg-violet-100 text-violet-800 border-violet-200",
  "Ready for Validation": "bg-gold/20 text-gold-dark border-gold/40",
  "Closed": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Rejected": "bg-red-100 text-red-800 border-red-200",
  "Deferred": "bg-slate-200 text-slate-700 border-slate-300",
};

export const EVIDENCE_TYPES = ["Screenshot", "Configuration export", "User list", "Device inventory", "Policy",
  "Procedure", "Training report", "Ticket", "Approval", "Log", "Scan report", "Diagram",
  "Interview confirmation", "Observation", "Implementer attestation", "Other"];

export const EVIDENCE_STATUSES = ["Not Requested", "Requested", "Received", "Under Review", "Accepted", "Rejected", "Expired", "Replaced"];

export const EVIDENCE_STATUS_STYLES = {
  "Not Requested": "bg-slate-100 text-slate-600 border-slate-200",
  "Requested": "bg-blue-100 text-blue-800 border-blue-200",
  "Received": "bg-violet-100 text-violet-800 border-violet-200",
  "Under Review": "bg-amber-100 text-amber-800 border-amber-200",
  "Accepted": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Rejected": "bg-red-100 text-red-800 border-red-200",
  "Expired": "bg-slate-200 text-slate-700 border-slate-300",
  "Replaced": "bg-slate-200 text-slate-700 border-slate-300",
};

// ---------------- Phase 3: Questions ----------------
export const QUESTION_CATEGORIES = [
  { value: "complyx", label: "ComplyX" },
  { value: "implementation_partner", label: "Implementation Partner" },
  { value: "client", label: "Client" },
];

export const QUESTION_STATUSES = ["Draft", "Approved", "Sent", "Answered", "Needs Follow-Up", "Resolved", "Closed"];

export const QUESTION_STATUS_STYLES = {
  "Draft": "bg-slate-100 text-slate-700 border-slate-200",
  "Approved": "bg-blue-100 text-blue-800 border-blue-200",
  "Sent": "bg-violet-100 text-violet-800 border-violet-200",
  "Answered": "bg-gold/20 text-gold-dark border-gold/40",
  "Needs Follow-Up": "bg-amber-100 text-amber-800 border-amber-200",
  "Resolved": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Closed": "bg-slate-200 text-slate-700 border-slate-300",
};

// ---------------- Phase 3: Reports ----------------
export const REPORT_TYPES = [
  { value: "executive", label: "Executive Readiness Report", audience: "customer" },
  { value: "detailed_internal", label: "Detailed Internal Reconciliation Report", audience: "internal" },
  { value: "partner_punch", label: "Implementation Partner Punch List", audience: "customer" },
  { value: "client_plan", label: "Client Action Plan", audience: "customer" },
  { value: "complyx_tasks", label: "ComplyX Internal Task Report", audience: "internal" },
  { value: "evidence_gap", label: "Evidence Gap Report", audience: "internal" },
  { value: "contradiction", label: "Contradiction Report", audience: "internal" },
];

export const CHANGE_TYPE_STYLES = {
  "Improved": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Regressed": "bg-red-100 text-red-800 border-red-200",
  "Newly Identified": "bg-amber-100 text-amber-800 border-amber-200",
  "Closed": "bg-slate-200 text-slate-700 border-slate-300",
  "Ownership Changed": "bg-violet-100 text-violet-800 border-violet-200",
  "Evidence Added": "bg-blue-100 text-blue-800 border-blue-200",
  "Evidence Removed": "bg-amber-100 text-amber-800 border-amber-200",
  "SSP Updated": "bg-blue-100 text-blue-800 border-blue-200",
  "No Material Change": "bg-slate-100 text-slate-500 border-slate-200",
};

// ---------------- Phase 4A: Evidence Blueprint Library ----------------
export const BP_EVIDENCE_TYPES = [
  "Technical configuration screenshot", "Configuration export", "Audit log", "Device inventory",
  "User or access list", "Operational record", "Policy", "Procedure", "Training record",
  "Approval record", "Ticket", "Risk assessment", "Incident record", "Physical evidence",
  "Reference documentation", "Other",
];
export const BP_OWNERS = ["Implementation Partner", "Client", "ComplyX", "Shared"];
export const BP_REVIEW_STATUSES = ["Draft", "Visually Reviewed", "Needs Re-Review", "Approved Blueprint", "Archived", "Rejected as Template"];
export const BP_REVIEW_STYLES = {
  "Draft": "bg-slate-100 text-slate-700 border-slate-200",
  "Visually Reviewed": "bg-blue-100 text-blue-800 border-blue-200",
  "Needs Re-Review": "bg-amber-100 text-amber-800 border-amber-200",
  "Approved Blueprint": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Archived": "bg-slate-200 text-slate-700 border-slate-300",
  "Rejected as Template": "bg-red-100 text-red-800 border-red-200",
};
export const BP_DIMENSIONS = [
  "Technical Configuration", "Policy", "Procedure", "Operational Execution", "Evidence",
  "SSP Accuracy", "Training", "Personnel Responsibility", "Ongoing Monitoring",
];
export const EXPECTED_STATUSES = ["Not Requested", "Requested", "Received", "Under Review", "Accepted", "Rejected",
  "Alternative Evidence Accepted", "Not Applicable", "Expired", "Replaced"];
export const EXPECTED_STATUS_STYLES = {
  "Not Requested": "bg-slate-100 text-slate-600 border-slate-200",
  "Requested": "bg-blue-100 text-blue-800 border-blue-200",
  "Received": "bg-violet-100 text-violet-800 border-violet-200",
  "Under Review": "bg-amber-100 text-amber-800 border-amber-200",
  "Accepted": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Rejected": "bg-red-100 text-red-800 border-red-200",
  "Alternative Evidence Accepted": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Not Applicable": "bg-slate-100 text-slate-500 border-slate-200",
  "Expired": "bg-slate-200 text-slate-700 border-slate-300",
  "Replaced": "bg-slate-200 text-slate-700 border-slate-300",
};

export const BP_TOOL_STATUSES = ["Not Yet Selected", "Microsoft-Native", "Existing Customer Tool",
  "Alternative Approved Tool", "Requires Review", "Not Applicable"];
export const BP_CUSTOMER_SYSTEM_TYPES = ["Microsoft 365", "IT Service Management", "Learning Management System",
  "Human Resources Information System", "Identity and Access Management", "Security Information and Event Management",
  "Endpoint Management", "Endpoint Detection and Response", "Backup and Recovery", "Governance, Risk, and Compliance",
  "Physical Security System", "Custom Internal Workflow", "Manual Controlled Process", "Other"];
export const TECH_CAPABILITIES = ["Identity", "MFA and Conditional Access", "Endpoint Management", "Endpoint Security",
  "SIEM", "Audit Logging", "CUI Storage", "Email", "Collaboration", "ITSM", "Access Requests", "Change Management",
  "Incident Management", "Training Management", "Policy Acknowledgment", "Risk Register", "Document Management",
  "Evidence Repository", "Backup and Recovery", "Physical Access", "Vulnerability Management", "Other"];
export const TECH_VALIDATION = ["Not Reviewed", "Approved for Use", "Approved with Conditions", "Not Approved for CUI",
  "Replacement Required", "Needs Additional Information"];
export const TECH_VALIDATION_STYLES = {
  "Not Reviewed": "bg-slate-100 text-slate-600 border-slate-200",
  "Approved for Use": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Approved with Conditions": "bg-blue-100 text-blue-800 border-blue-200",
  "Not Approved for CUI": "bg-red-100 text-red-800 border-red-200",
  "Replacement Required": "bg-red-100 text-red-800 border-red-200",
  "Needs Additional Information": "bg-amber-100 text-amber-800 border-amber-200",
};
